import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlay = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.75076 2.25202C5.22228 1.92707 4.55811 1.91636 4.01892 2.21988C3.47973 2.5234 3.14407 3.09472 3.14407 3.71604V16.2852C3.14407 16.9066 3.47973 17.4779 4.01892 17.7814C4.55811 18.0849 5.22228 18.0706 5.75076 17.7493L16.0347 11.4647C16.5453 11.154 16.8559 10.6005 16.8559 10.0006C16.8559 9.40075 16.5453 8.85085 16.0347 8.53662L5.75076 2.25202Z",
		fill: "#0D2976"
	})
});
export default SvgPlay;
